import React from 'react';
import styled from 'styled-components';
import { TextField, Select, MenuItem, FormControl } from '@mui/material';

const QuantityTitle = {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.01em',
    color: '#222C31',
};

const IncrementContainer = styled.div`
    padding-top: 10px;
    display: flex;
    align-items: center;
    margin: 10px 0px 0px 0px;
`;

const IncrementButton = styled.div`
    width: 23px;
    height: 23px;
    color: #7777f7;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    margin: 0px 10px 5px;
    ${({ disabled }) =>
        disabled &&
        `opacity: 0.5; 
     pointer-events: none; 
     `}
    &:hover {
        background-color: '#81ecec';
    }
`;

export function QuantityInput({
    minQuantity,
    quantity,
    setQuantity,
    uom,
    setUom,
    uomItems = [
        'items',
        'slices',
        'buns',
        'people',
        'units',
        'pairs',
        'boxes',
        'pcs',
        'quarts',
        'gallons',
    ], // Default values if not provided
}) {
    return (
        <IncrementContainer>
            <div className={QuantityTitle}>
                <b>Quantity {minQuantity && `(min ${minQuantity})`}</b>
            </div>
            <IncrementButton
                onClick={() => {
                    setQuantity(quantity - 1);
                }}
                disabled={quantity === (minQuantity ? minQuantity : 1)}
            >
                <i
                    className="fas fa-minus-circle"
                    style={{ fontSize: '27px' }}
                ></i>
            </IncrementButton>
            <TextField
                type="number"
                value={quantity}
                onChange={(e) => {
                    const value = parseInt(e.target.value);
                    // if (value >= 1) {
                    setQuantity(value);
                    //}
                }}
                onBlur={(e) => {
                    let valToCheck = minQuantity || 1;
                    if (e.target.value === '' || e.target.value < valToCheck) {
                        setQuantity(valToCheck);
                    }
                }}
                inputProps={{
                    min: 1,
                    style: { textAlign: 'center' },
                    //onWheel: (e) => e.preventDefault(),
                }}
                sx={{
                    ml: 0.5,
                    mr: 0.5,
                    width: '60px',
                    '& .MuiOutlinedInput-root': {
                        height: '32px',
                    },
                    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
                        {
                            '-webkit-appearance': 'none',
                            margin: 0,
                        },
                    '& input[type=number]': {
                        '-moz-appearance': 'textfield',
                    },
                }}
                size="small"
            />
            <IncrementButton
                onClick={() => {
                    setQuantity(quantity + 1);
                }}
            >
                <i
                    className="fas fa-plus-circle"
                    style={{ fontSize: '27px' }}
                ></i>
            </IncrementButton>
            <FormControl sx={{ minWidth: 90 }}>
                <Select
                    value={uom}
                    onChange={(e) => setUom(e.target.value)}
                    size="small"
                    MenuProps={{ disablePortal: true }}
                    sx={{
                        height: '32px',
                        '& .MuiSelect-select': {
                            paddingTop: '6px',
                            paddingBottom: '6px',
                        },
                    }}
                >
                    {uomItems.map((item) => (
                        <MenuItem key={item} value={item}>
                            {item}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </IncrementContainer>
    );
}
